module.exports = __webpack_public_path__ + "static/media/Portrait-10258.8e40a27b.jpg";